// Canonical event taxonomy. Frozen set; any new event must be added here first.
// Naming convention: noun_verb. All lowercase, snake_case. Past tense for actions.

export const EVENTS = {
  // Client-side: page-level. Uses PostHog's reserved $pageview name so the
  // built-in Web Analytics dashboard (which is hardcoded to look for $pageview)
  // populates without a custom dashboard.
  PAGE_VIEW: '$pageview',

  // Client-side: scrolling-story surface (apps/landing)
  BEAT_VIEW: 'beat_view',
  BEAT_DWELL: 'beat_dwell',
  BACKSCROLL_OBSERVED: 'backscroll_observed',

  // Client-side: landing-static surface (sections, single page)
  SECTION_VIEW: 'section_view',
  SECTION_DWELL: 'section_dwell',

  // Client-side: shared
  SCROLL_MILESTONE: 'scroll_milestone',
  CTA_CLICKED: 'cta_clicked',
  CONTACT_FORM_STARTED: 'contact_form_started',
  CONTACT_FORM_FIELD_FOCUSED: 'contact_form_field_focused',
  CONTACT_FORM_COMPLETED: 'contact_form_completed',
  CONTACT_FORM_ABANDONED: 'contact_form_abandoned',
  EXTERNAL_LINK_CLICKED: 'external_link_clicked',
  EXPERIMENT_EXPOSED: 'experiment_exposed',
  REDUCED_MOTION_ACTIVE: 'reduced_motion_active',

  // Server-side: authoritative submission events (worker)
  CONTACT_SUBMIT_SUCCEEDED: 'contact_submit_succeeded',
  CONTACT_SUBMIT_FAILED: 'contact_submit_failed',
  CONTACT_RATE_LIMITED: 'contact_rate_limited',
  CONTACT_TURNSTILE_FAILED: 'contact_turnstile_failed',
  SUBSCRIPTION_PENDING: 'subscription_pending',
  SUBSCRIPTION_CONFIRMED: 'subscription_confirmed',
} as const;

export type EventName = typeof EVENTS[keyof typeof EVENTS];

/** Runtime set used for validation. */
const EVENT_NAME_SET: ReadonlySet<string> = new Set(Object.values(EVENTS));

export function isValidEventName(value: string): value is EventName {
  return EVENT_NAME_SET.has(value);
}

/** List form for tests / catalog dumps. Stable iteration order. */
export const EVENT_NAMES: readonly EventName[] = Object.values(EVENTS);
